type StoryStepMetaLike = {
  source: string;
  visible: boolean;
};

export const shouldIncludeStoryMessage = ({
  storyMeta,
  sourceFilter,
  showHiddenSteps,
}: {
  storyMeta: StoryStepMetaLike | null;
  sourceFilter: string;
  showHiddenSteps: boolean;
}): boolean => {
  if (!storyMeta) {
    return sourceFilter === 'all';
  }

  if (sourceFilter !== 'all' && storyMeta.source !== sourceFilter) {
    return false;
  }

  if (!showHiddenSteps && !storyMeta.visible) {
    return false;
  }

  return true;
};
